import { Box, Container, Grid, Stack, Typography, Link as MuiLink, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { LEGAL_LINKS, PATHS } from '../../routes';
import { BRAND } from '../../theme/palette';

// Structure reused from references/ProdWebsite/frontend/src/components/Footer/footer.js
// per New Website.docx's instruction to copy the global footer pages.
export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: BRAND.footerBackground, color: 'rgba(255,255,255,0.88)' }}>
      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: '#fff', mb: 2 }}>
              Corporate
            </Typography>
            <Stack spacing={1.2}>
              <Typography variant="body1">5600 S Quebec St, Ste 100-D</Typography>
              <Typography variant="body1">Greenwood Village, CO 80111</Typography>
              <MuiLink
                component={RouterLink}
                to={PATHS.businessProfiles}
                underline="none"
                sx={{ color: 'inherit', '&:hover': { color: '#fff' }, mt: 1, display: 'inline-block' }}
              >
                View all locations →
              </MuiLink>
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: '#fff', mb: 2 }}>
              Legal
            </Typography>
            <Stack spacing={1.2}>
              {LEGAL_LINKS.map((link) => (
                <MuiLink
                  key={link.path}
                  component={RouterLink}
                  to={link.path}
                  underline="none"
                  sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}
                >
                  {link.label}
                </MuiLink>
              ))}
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
              <Box
                component="img"
                src="/assets/ehl-badge.png"
                alt="Equal Housing Lender"
                sx={{ height: 52, width: 'auto' }}
              />
            </Box>

            <Typography variant="body2" sx={{ mb: 0.5 }}>
              For licensing information, visit
            </Typography>
            <MuiLink
              href="https://www.nmlsconsumeraccess.org"
              target="_blank"
              rel="noopener"
              underline="none"
              sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}
            >
              www.nmlsconsumeraccess.org
            </MuiLink>
          </Grid>
        </Grid>
      </Container>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)' }} />

      <Container maxWidth="lg">
        <Typography variant="caption" sx={{ display: 'block', py: 3, color: 'rgba(255,255,255,0.78)', lineHeight: 1.6 }}>
          © Cherry Creek Mortgage, LLC. Equal Housing Lender. All products are subject to credit and property approval.
          Programs, rates, program terms and conditions subject to change without notice. Not all products are
          available in all states or for all amounts. Other restrictions and limitations apply. This is not a
          commitment to lend.
        </Typography>
      </Container>
    </Box>
  );
}
